// extracted by mini-css-extract-plugin
export default {"fallback":"AsyncLoad_fallback__rM4jS","center":"AsyncLoad_center__SQnhZ"};